/* eslint-disable @typescript-eslint/no-explicit-any */
import MenuItem from "@mui/material/MenuItem"

import { SelectChangeEvent } from "@mui/material/Select"
import { useQuery } from "@tanstack/react-query"
import { useCallback, useMemo } from "react"
import storeApis from "src/api/stores"
import { STORES } from "src/constants/queryKeys"
import { theme } from "src/providers/ThemeProvider"
import { SelectField, Text } from "src/shared"
import PlaceholderSelectItem from "./PlaceholderSelectItem"
import ShopSelectItem from "./ShopSelectItem"

interface ShopSelectionProps {
  onChange: (val?: string) => void
  value?: string
}

const ShopSelection = ({
  value: selectedValue = "",
  onChange,
}: ShopSelectionProps) => {
  const { data } = useQuery({
    queryKey: [STORES],
    queryFn: () =>
      storeApis.gets({
        pageIndex: 0,
        pageSize: 100,
      }),
  })

  const options = useMemo(() => {
    if (data && data.Result && data.Result.length) {
      const mapData = data.Result.map(m => ({
        StoreCode: m.StoreCode,
        Address: m.Address,
        StoreName: m.StoreName,
        StoreStatus: m.StoreStatus,
        value: m.StoreCode,
        label: m.StoreName,
      }))
      return mapData.sort((a, b) => (a.StoreStatus > b.StoreStatus ? -1 : 1))
    }
    return []
  }, [data])

  const renderValue = useCallback(
    (selectedValue: string) => {
      const label = options.find(x => x.value === selectedValue)?.label
      return (
        <Text
          lineHeight="21px"
          color={theme.palette.common.black}
          fontSize={16}
          textOverflow="ellipsis"
          overflow="hidden"
        >
          {label}
        </Text>
      )
    },
    [options]
  )
  const handleChange = useCallback(
    (e: SelectChangeEvent) => {
      const {
        target: { value },
      } = e
      onChange(value === "remove" ? undefined : value)
    },
    [onChange]
  )

  return (
    <SelectField
      defaultValue={""}
      MenuProps={{
        marginThreshold: 0,
        sx: {
          "& .MuiPaper-root": {
            borderRadius: theme.spacing(3.75, 3.75, 0, 0),
            maxWidth: 526,
            [theme.breakpoints.down(600)]: {
              maxWidth: "100%",
              width: "100%",
            },
          },
          "& .MuiList-root": {
            padding: "0px",
            [theme.breakpoints.down(600)]: {
              "& > li": {
                padding: theme.spacing(1.5),
              },
            },
          },
        },
      }}
      placeholder="Chọn cửa hàng đổi quà"
      options={options}
      onChange={handleChange}
      renderValue={renderValue}
      value={selectedValue}
    >
      <MenuItem
        sx={{
          padding: theme.spacing(2.75, 2.5),
          cursor: "default",
          position: "sticky",
          top: 0,
          zIndex: 999,
          backgroundColor: `${theme.palette.common.white} !important`,
        }}
        value="remove"
      >
        <PlaceholderSelectItem />
      </MenuItem>
      {options
        .filter(o => o.StoreCode)
        .map(o => {
          return (
            <MenuItem
              sx={{
                borderTop: `solid 1px ${theme.palette.grey[200]}`,
                padding: theme.spacing(2.75, 2.5),
              }}
              key={o.StoreCode}
              value={o.StoreCode}
            >
              <ShopSelectItem isChecked={selectedValue === o.value} data={o} />
            </MenuItem>
          )
        })}
    </SelectField>
  )
}

export default ShopSelection
